"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FelaTippy = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("@tippyjs/react"));
const react_fela_1 = require("react-fela");
const useQuickAsync_1 = require("../../hooks/useQuickAsync");
const VibescoutFrontendStyleConfig_1 = require("../config/VibescoutFrontendStyleConfig");
const FelaRuleTippy = ({ theme }) => {
    const background = !theme.dark
        ? theme.styles.RgbColors.lightBack.lig
        : theme.styles.RgbColors.darkBack.lig;
    return {
        fontFamily: theme.styles.Font.family[VibescoutFrontendStyleConfig_1.ETextTypographyType.sansSerif],
        color: !theme.dark ? theme.styles.RgbColors.lightFore.dar : theme.styles.RgbColors.darkFore.lig,
        opacity: 0.9,
        boxShadow: "0 0 0.25em rgba(0,0,0,0.35), 0 0.5em 0.5em rgba(0,0,0,0.35)",
        background,
        "> .tippy-backdrop": {
            background,
        },
        "> .tippy-arrow": {
            borderTop: `8px solid ${background} !important`,
        },
    };
};
const FelaTippy = ({ children, ...props }) => {
    const { css } = (0, react_fela_1.useFela)({ size: 0.8 });
    (0, useQuickAsync_1.useQuickClientAsync)("tippy-css", async () => {
        // @ts-ignore
        await Promise.resolve().then(() => __importStar(require("tippy.js/dist/tippy.css")));
        // @ts-ignore
        await Promise.resolve().then(() => __importStar(require("tippy.js/themes/light.css")));
    });
    return ((0, jsx_runtime_1.jsx)(react_1.default, { arrow: true, className: css(FelaRuleTippy), ...props, children: children }));
};
exports.FelaTippy = FelaTippy;
